import { type App } from 'vue';
import 'vuetify/styles';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@/assets/scss/vuetify/global.scss';
import { ru } from 'vuetify/locale';

const theme: ThemeDefinition = {
  dark: false,
  colors: {
    black: '#131316',
    secondary: '#606269',
    primary: '#2B6EF2',
    ordinary: '#9296A0',
    green: '#33B960',
    red: '#E32222',
    inactive: '#C2C6D2',
    link: '#5B8FF5',
    yellow: '#ECB802',
  },
};

export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'theme',
    themes: {
      theme,
    },
  },
  locale: {
    locale: 'ru',
    fallback: 'ru',
    messages: {
      ru,
    },
  },
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1280,
      xl: 1640,
    },
  },
});

export function vuetifyPlugin(app: App) {
  app.use(vuetify);

  app.config.globalProperties.$vuetify = vuetify;
}
